import { render } from "./ordersComponent.vue?vue&type=template&id=1f1e5ca0&scoped=true"
import script from "./ordersComponent.vue?vue&type=script&lang=js"
export * from "./ordersComponent.vue?vue&type=script&lang=js"

import "./ordersComponent.vue?vue&type=style&index=0&id=1f1e5ca0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1e5ca0"]])

export default __exports__